import { Link } from 'react-router-dom';
import '../styles/Footer.css';

import NavigationList from './NavigationList';
import SocialMedias from './SocialMedias';

import footerLogo from '../../images/icons/logo-footer.svg';

function Footer() {

    return (

        <footer className='footer_c'>

            <div className='navigation_list'>

                <Link to='/'>

                    <img className='logo_footer' src={footerLogo} alt='logo' />

                </Link>

                <NavigationList type='footer_item' />

            </div>

            <SocialMedias type='social_footer' />

        </footer>

    )

}

export default Footer;